import {
  backgroundColorCss,
  borderCss,
  colorCss,
  fontSizeCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { CouponButtonInterface } from '../coupon-ui.schema'

interface CouponButtonUiProps extends Omit<CouponButtonInterface, 'text'> {
  checking?: boolean
}

export const CouponButtonUi = styled.button<CouponButtonUiProps>`
  padding: 5px 8px;
  outline: none;
  transition: opacity 0.2s ease;
  cursor: pointer;
  opacity: ${p => (p.checking ? 0.5 : 1)};

  ${fontSizeCss}
  ${colorCss}
  ${backgroundColorCss}
  ${borderCss}
    
  ${p => p.theme.phone} {
    width: 100%;
    ${mobileFontSizeCss}
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    width: 100%;
    ${mobileFontSizeCss}
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
    ${mobileBorderCss}
  `}
`
